import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/AppFeatureBranch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/DatadogRumSyncClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/share/Layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/share/ShareData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DeviceContextProvider"] */ "/home/vsts/work/1/s/merch-ui/src/context/common/DeviceContext.tsx");
